import useSWR from "swr";
import { getIgnoreLists } from "./service";
import { UseIgnoreListsModel } from "./types";

const useIgnoreLists = (): UseIgnoreListsModel => {
  const { data, error, isLoading, mutate } = useSWR(`/ignore-list`, () =>
    getIgnoreLists(),
  );

  return {
    data,
    isLoading,
    error,
    mutate,
  };
};

export default useIgnoreLists;
